import gql from 'graphql-tag';

export default gql`
  mutation setDraftOrderDeliveryNote($input: SetDraftOrderDeliveryNoteInput!) {
    setDraftOrderDeliveryNote(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
